import { render, staticRenderFns } from "./vue-scrollbar.vue?vue&type=template&id=2ba03c90"
import script from "./vue-scrollbar.vue?vue&type=script&lang=js"
export * from "./vue-scrollbar.vue?vue&type=script&lang=js"
import style0 from "./vue-scrollbar.vue?vue&type=style&index=0&id=2ba03c90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports